import React from 'react'
import 'assets/fonts/pillar-interface/pillar-interface.css'
import 'assets/fonts/socicon/socicon.css'
import 'assets/fonts/iconsmind/iconsmind.css'
import 'assets/css/bootstrap.css'
import './styles.css'
import Navigation from 'components/Navigation'
import Footer from 'components/Footer'

const defaultOpt = {
  nav: {
    position: 'fixed',
    transparent: false
  }
}

export default function withApp(WrappedComponent, opt = {}) {
  return class App extends React.Component {
    constructor(props) {
      super(props)

      this.opt = {...defaultOpt}
      this.opt.nav = {...defaultOpt.nav, ...opt.nav}
    }

    render = () => {
      const {nav} = this.opt

      return (
        <div>
          <Navigation {...nav}/>
          <WrappedComponent {...this.props}/>
          <Footer/>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/App/index.js